const trains = [
  { id: 1, name: "Rajdhani Express", from: "Mumbai", to: "Delhi", time: "09:00 AM", price: 1500 },
  { id: 2, name: "Shatabdi Express", from: "Delhi", to: "Bhopal", time: "07:15 AM", price: 1200 },
  { id: 3, name: "Duronto Express", from: "Pune", to: "Howrah", time: "08:00 PM", price: 2000 },
  { id: 4, name: "Garib Rath", from: "Chennai", to: "Bangalore", time: "05:00 AM", price: 800 },
  { id: 5, name: "Intercity Express", from: "Hyderabad", to: "Vijayawada", time: "06:30 AM", price: 700 },
  { id: 6, name: "Vande Bharat", from: "Delhi", to: "Varanasi", time: "06:00 AM", price: 1800 },
  { id: 7, name: "Jan Shatabdi", from: "Nagpur", to: "Bhopal", time: "01:00 PM", price: 950 },
  { id: 8, name: "Tejas Express", from: "Mumbai", to: "Goa", time: "05:45 AM", price: 1600 },
  { id: 9, name: "Humsafar Express", from: "Kolkata", to: "Patna", time: "03:20 PM", price: 1100 },
  { id: 10, name: "Maharaja Express", from: "Delhi", to: "Agra", time: "08:00 AM", price: 5000 },
];
export default trains;
